import React from "react";
import classes from "./styles.module.scss";
import classNames from "classnames";

type Size = "lg" | "sm";

type Color = "arctic";

interface ChipProps extends React.HTMLAttributes<HTMLElement> {
   size?: Size;
   color?: Color;
   before?: React.ReactNode;
   after?: React.ReactNode;
   tag?: React.ElementType;
   className?: string;
}

interface ChipContentProps extends React.HTMLAttributes<HTMLElement> {
   tag?: React.ElementType;
   className?: string;
}

export const ChipBefore = React.forwardRef<HTMLElement, ChipContentProps>(({ tag = "div", className, ...rest }, ref) =>
   React.createElement(tag, { ref, className: classNames(classes.before, className), ...rest }));

export const ChipContent = React.forwardRef<HTMLElement, ChipContentProps>(({ tag = "div", className, ...rest }, ref) =>
   React.createElement(tag, { ref, className: classNames(classes.content, className), ...rest }));

export const ChipAfter = React.forwardRef<HTMLElement, ChipContentProps>(({ tag = "div", className, ...rest }, ref) =>
   React.createElement(tag, { ref, className: classNames(classes.after, className), ...rest }));

const Chip = React.forwardRef<HTMLElement, ChipProps>(({ tag = "div", size = "sm", color = "arctic", className, children, ...rest }, ref) =>
   React.createElement(tag, {
      ref,
      className: classNames(className, classes.container, classes[`container-${size}`], classes[`container-${color}`]),
      children: typeof children === "string"
         ? <ChipContent>{children}</ChipContent>
         : children,
      ...rest
   }));

export default Chip;